import React from 'react';
import { toast } from 'sonner';
import { AlertTriangle, Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function BackupCodesView({ codes, onContinue }) {
  const copy = () => {
    navigator.clipboard?.writeText(codes.join('\n'));
    toast.success('Recovery codes copied');
  };

  return (
    <>
      <div className="grid grid-cols-2 gap-2 rounded-lg border border-slate-700 bg-slate-950 p-4" data-testid="backup-codes-list">
        {codes.map((bc) => (
          <code key={bc} className="text-center font-mono text-sm text-emerald-300">{bc}</code>
        ))}
      </div>
      <div className="flex items-start gap-2 rounded-lg bg-amber-500/10 p-3 text-xs text-amber-300">
        <AlertTriangle className="h-4 w-4 shrink-0 mt-0.5" />
        These won&apos;t be shown again. An admin can reset your 2FA if you lose access.
      </div>
      <div className="flex gap-2">
        <Button variant="outline" className="flex-1 border-slate-700 bg-transparent text-slate-200 hover:bg-slate-800" onClick={copy} data-testid="copy-backup-codes-btn">
          <Copy className="mr-2 h-4 w-4" /> Copy
        </Button>
        <Button className="flex-1 bg-indigo-600 hover:bg-indigo-500" onClick={onContinue} data-testid="backup-continue-btn">
          I&apos;ve saved them — continue
        </Button>
      </div>
    </>
  );
}
